<template>
  <el-dialog title="空气环境条件控制" :visible.sync="show" width="60%">
    <div style="height: 360px">
      <el-alert type="success" :closable="false">
        闷棚（土壤处理）期，采取各种措施提升并保持较高的环境温度。空气温度和空气湿度没有具体量化要求。
        基于模型的自动控制请至“综合营养”板块查看
      </el-alert>
      <el-row class="mt-3">
        <el-col span="6">
          <h5>实时空气温度</h5>
          <p>56.8 <span class="font-size:12px">℃</span></p>

          <h5>实时空气湿度</h5>
          <p>73.2 <span class="font-size:12px">%RH</span></p>

        </el-col>
        <el-col span="6">
          <h5>空气温度建议范围</h5>
          <p>--</p>

          <h5>空气湿度建议范围</h5>
          <p>--</p>

        </el-col>
        <el-col span="12">
          <h5>建议</h5>
          <p>建议棚内温度尽量保持较高，此阶段没有智能控制建议。</p>

          <h5>遮阳控制</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>

          <h5>通风控制</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/welcome/LandGuideAirDialog.vue